import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { clx } from 'Utils';
import { Button, Card, FontAwesome } from 'Elements';
import styles from 'partials/homepage/section/profile-hero-header.module.scss';
import { Colors } from 'src/types/Color';

interface Props {
	icon: string;
	title: string;
	desc: string;
	fill: string;
	item?: any;
	isEdit?: boolean;
	className?: string;
	toggleModalDelete: () => void;
	toggleModalAdd: () => void;
	onClick: (value: any) => void;
}

export const ProfileStatisticCard: FC<Props> = ({
	icon,
	title,
	desc,
	item,
	fill,
	className,
	isEdit,
	onClick,
	toggleModalDelete,
	toggleModalAdd
}) => {
	const { t } = useTranslation();
	// if (!desc) return;
	return (
		<Card className={clx(styles.card, 'h-100')}>
			<div
				className={clx(
					'd-flex flex-column align-items-center justify-content-center text-center gap-2',
					className
				)}>
				<FontAwesome icon={icon} size="3x" color={fill} />
				<h5 className="h6 lh-base mb-0 mt-2 text-gray-5">{t(title)}</h5>
				<div className="text-break lh-base w-100 fs-base">
					<span className="text-break lh-base w-100 fs-base">
						{desc}
					</span>
				</div>
			</div>
			{isEdit && (
				<div className="edit-overlay-statistic">
					<div className="d-flex m-2 gap-2">
						<Button
							disabled={false}
							className="p-2"
							color={Colors['white-red']}
							onClick={() => {
								onClick(item);
								toggleModalDelete();
							}}>
							<FontAwesome icon="trash-xmark" size="lg" />
						</Button>
						<Button
							color={Colors['white-primary']}
							className="p-2"
							disabled={false}
							onClick={() => {
								onClick(item);
								toggleModalAdd();
							}}>
							<FontAwesome icon="pen" size="lg" />
						</Button>
					</div>
				</div>
			)}
		</Card>
	);
};
